<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>WebHook Personalizado Vendas</h3>
      </div>
      <div class="box-content">
        <p>
          Configure o nosso webhook no seu painel. Basta copiar o link
          do webhook abaixo e cadastrar no painel.
        </p>
        <form>
          <div>
            <input
              class="input"
              type="text"
              v-model="urlWebhook"
              readonly="true"
            />
          </div>
          <div class="margin-top-s">
            <div class="button primary" @click="copyLink(urlWebhook)">
              Copiar webhook
            </div>
          </div>
        </form>
        <div class="margin-top-l">
          <p>
            Para garantir o funcionamento correto da integração você precisa
            cadastrar o webhook para todos seus produtos e todos os status
            possíveis.
          </p>
        </div>

        <div class="margin-top-l">
          <p>
            Exemplo de como precisa ser enviados os dados. Lembrando que sempre precisa ser uma mensagem do tipo POST com as informações em JSON na requisição.
          </p>
          <div class="flex w100 code margin-top-l" v-html="customFormat">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "custom-sales",
  data() {
    return {
      baseUrlWebhook: "https://wh.unicotracker.com.br/webhook/v1/sale/customv2/",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    urlWebhook() {
      return `${this.baseUrlWebhook}${this.account.id}/`;
    },
    customFormat() {
      return `
{<br>
    "order_id": "XXXXXXXXXXXXXXXXXXXXXXXX",<br>
    "order_status": "paid",<br>
    "product_type": "membership",<br>
    "payment_method": "credit_card",<br>
    "sale_type": "producer",<br>
    "created_at": "2024-08-04 17:52",<br>
    "updated_at": "2024-08-04 17:52",<br>
    "approved_date": "2024-08-04 17:52",<br>
    "refunded_at": null,<br>
    "webhook_event_type": "order_approved",<br>
    "Product": {<br>
        "product_id": "XXXXXXXXXXXXXXXX",<br>
        "product_name": "xxxxxxxxxxxxxxxxxxxxxxxxxx"<br>
    },<br>
    "Customer": {<br>
        "full_name": "xxxxxxxxxxxxx",<br>
        "first_name": "xxxx",<br>
        "email": "xxxx@gmail.com",<br>
        "mobile": "",<br>
        "CPF": "",<br>
        "ip": "XXXXXXXXXX"<br>
    },<br>
    "Commissions": {<br>
        "product_base_price": 2700,<br>
        "currency": "BRL",<br>
        "my_commission": 431<br>
    },<br>
    "TrackingParameters": {<br>
        "src": "",<br>
        "sck": "",<br>
        "utm_source": "",<br>
        "utm_medium": "",<br>
        "utm_campaign": "",<br>
        "utm_content": "",<br>
        "utm_term": ""<br>
    }<br>
}<br>
`
    }
  },
  mounted() {},
  methods: {
    copyLink(link) {
      let copyText = link;
      navigator.clipboard.writeText(copyText);

      this.$toast.success({
        title: "Sucesso",
        message: "Link do Webhook copiado!",
      });
    },
  },
};
</script>
